export default (mapper = {}, initialState = {}) => (
  (state = initialState, action) => {
    const actionReducer = mapper[action.type]
    return actionReducer ? actionReducer(state, action) : state
  }
)



// WEBPACK FOOTER //
// ./src/store/reducerGenerator.js